/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Presentation_Templates_Empty_Or_ManualInputs */



/**
* | output |
* | --- |
* | "Rather pick colours and fonts by hand?" |
*
* @param {Presentation_Templates_Empty_Or_ManualInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const presentation_templates_empty_or_manual = /** @type {((inputs?: Presentation_Templates_Empty_Or_ManualInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Presentation_Templates_Empty_Or_ManualInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Lieber Farben und Schriften selbst festlegen?")
	return /** @type {LocalizedString} */ ("Rather pick colours and fonts by hand?")
});